import { GridFooterCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

export const AmountFooterCell: FC<GridFooterCellProps> = (props) => {
  const { field = '' } = props;
  const splitOption = useContextSelector(InvoiceContext, (value) => value.splitOption);
  const totalAmount = useContextSelector(InvoiceContext, (value) => value.totalAmount);

  const total = totalAmount(field);

  return (
    <td>
      <div className="font-bold flex justify-center">
        {splitOption === 'Percentage' ? (
          <span> {total.toFixed(2)}%</span>
        ) : (
          <span>{total.toFixed(2)}</span>
        )}
      </div>
    </td>
  );
};

export const GLFooterCell: FC<GridFooterCellProps> = (props) => (
  <td>
    <div className="flex justify-end">
      <span className="font-bold">Total Amount:</span>
    </div>
  </td>
);
